import { PageHeader, SectionLabel, Card, Stat, SampleBanner, StatusPill, Sparkline, BarTrack } from '../components/ui.js';

interface TrackedQuery {
  id: string;
  query: string;
  intent: 'who' | 'where' | 'best' | 'compare';
  citations: { chatgpt: number; perplexity: number; gemini: number; claude: number };
  trend: number[];
}

const QUERIES: TrackedQuery[] = [
  { id: 'q-001', query: 'best dentist in gilbert az', intent: 'best', citations: { chatgpt: 4, perplexity: 6, gemini: 3, claude: 5 }, trend: [0, 0, 1, 1, 2, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 16, 17, 17, 18, 18, 18, 18, 18, 18] },
  { id: 'q-002', query: 'dentist that accepts ahcccs in mesa', intent: 'who', citations: { chatgpt: 8, perplexity: 7, gemini: 5, claude: 7 }, trend: [2, 3, 4, 5, 7, 8, 10, 12, 14, 15, 16, 18, 19, 20, 21, 22, 23, 24, 24, 25, 25, 26, 26, 27, 27, 27, 27, 27, 27, 27] },
  { id: 'q-003', query: 'same day crowns near me glendale', intent: 'where', citations: { chatgpt: 3, perplexity: 4, gemini: 2, claude: 3 }, trend: [0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12] },
  { id: 'q-004', query: 'composite vs amalgam fillings', intent: 'compare', citations: { chatgpt: 2, perplexity: 3, gemini: 2, claude: 4 }, trend: [0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11] },
  { id: 'q-005', query: 'emergency dentist gilbert open saturday', intent: 'where', citations: { chatgpt: 5, perplexity: 5, gemini: 4, claude: 6 }, trend: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20] },
  { id: 'q-006', query: 'invisalign cost mesa az', intent: 'compare', citations: { chatgpt: 2, perplexity: 1, gemini: 1, claude: 2 }, trend: [0, 0, 0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6] },
  { id: 'q-007', query: 'pediatric dentist glendale arizona', intent: 'who', citations: { chatgpt: 4, perplexity: 5, gemini: 3, claude: 5 }, trend: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 15, 16, 16, 17, 17, 17, 17, 17, 17, 17, 17, 17, 17, 17, 17] },
  { id: 'q-008', query: 'dental implants near me gilbert', intent: 'where', citations: { chatgpt: 6, perplexity: 4, gemini: 3, claude: 5 }, trend: [4, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 14, 15, 15, 16, 16, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18] },
  { id: 'q-009', query: 'sedation dentistry mesa', intent: 'where', citations: { chatgpt: 1, perplexity: 2, gemini: 1, claude: 2 }, trend: [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 6, 6, 6, 6, 6] },
  { id: 'q-010', query: 'is dr. dawood a good dentist', intent: 'who', citations: { chatgpt: 7, perplexity: 8, gemini: 6, claude: 8 }, trend: [5, 6, 7, 8, 10, 12, 14, 16, 18, 19, 20, 22, 23, 24, 25, 26, 27, 28, 28, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29] },
  { id: 'q-011', query: 'whitening that actually works gilbert', intent: 'best', citations: { chatgpt: 3, perplexity: 2, gemini: 1, claude: 3 }, trend: [0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9] },
  { id: 'q-012', query: 'dentist for anxious patients glendale', intent: 'who', citations: { chatgpt: 3, perplexity: 4, gemini: 2, claude: 4 }, trend: [1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 13, 13, 13, 13] },
  { id: 'q-013', query: 'family dentist that takes ahcccs', intent: 'who', citations: { chatgpt: 5, perplexity: 6, gemini: 4, claude: 6 }, trend: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21] },
  { id: 'q-014', query: 'how much does a crown cost', intent: 'compare', citations: { chatgpt: 1, perplexity: 1, gemini: 0, claude: 2 }, trend: [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4] },
  { id: 'q-015', query: 'pediatric dentist mesa accepts ahcccs', intent: 'who', citations: { chatgpt: 6, perplexity: 5, gemini: 4, claude: 7 }, trend: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 22, 22, 22, 22, 22] },
];

export function AieoPage() {
  const totalCitations = QUERIES.reduce((s, q) => s + q.citations.chatgpt + q.citations.perplexity + q.citations.gemini + q.citations.claude, 0);
  const tracked = QUERIES.length;
  const aieoScore = Math.round((totalCitations / (tracked * 4 * 10)) * 100);
  const scoreTrend = [38, 41, 43, 47, 49, 52, 54, 56, 58, 59, 61, 62, 63, 64, 65, 66, 67, 68, 68, 69, 69, 70, 70, 71, 71, 72, 72, 72, 72, 72];

  const platformTotals = {
    chatgpt: QUERIES.reduce((s, q) => s + q.citations.chatgpt, 0),
    perplexity: QUERIES.reduce((s, q) => s + q.citations.perplexity, 0),
    gemini: QUERIES.reduce((s, q) => s + q.citations.gemini, 0),
    claude: QUERIES.reduce((s, q) => s + q.citations.claude, 0),
  };
  const platformMax = Math.max(...Object.values(platformTotals));

  return (
    <div className="space-y-12">
      <PageHeader
        eyebrow="AI Engine Optimization"
        title={<>How often AI engines <em className="text-cream/80">cite you.</em></>}
        subtitle="Bloom monitors ChatGPT, Perplexity, Gemini, and Claude across 15 tracked queries — and writes content engineered to be cited."
      />
      <SampleBanner />

      <section>
        <SectionLabel>AIEO score</SectionLabel>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Card>
            <div className="text-[10px] uppercase tracking-[0.22em] text-cream/40">Score (90d trend)</div>
            <div className="font-serif text-6xl text-cream tracking-tightest mt-2 tabular-nums">{aieoScore}</div>
            <div className="text-[11px] text-cream/45 mt-1">0-100, higher is better</div>
            <div className="mt-4"><Sparkline values={scoreTrend} height={56} color="rgba(165, 243, 252, 0.7)" /></div>
            <div className="mt-2 text-[11px] text-emerald-300/70">+34 since Bloom started</div>
          </Card>
          <Card>
            <div className="text-[10px] uppercase tracking-[0.22em] text-cream/40 mb-4">Citations by platform</div>
            <div className="space-y-3">
              {(['chatgpt', 'perplexity', 'gemini', 'claude'] as const).map((p) => (
                <div key={p}>
                  <div className="flex items-center justify-between text-sm mb-1">
                    <span className="text-cream/75 capitalize">{p}</span>
                    <span className="text-cream tabular-nums">{platformTotals[p]}</span>
                  </div>
                  <BarTrack value={platformTotals[p]} max={platformMax} tone="ok" />
                </div>
              ))}
            </div>
          </Card>
        </div>
      </section>

      <section>
        <SectionLabel>Last 30 days</SectionLabel>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <Stat label="Tracked queries" value={tracked} />
          <Stat label="Total citations" value={totalCitations} tone="ok" />
          <Stat label="Avg per query" value={(totalCitations / tracked).toFixed(1)} />
          <Stat label="Cited ≥ 1 platform" value={QUERIES.filter((q) => q.citations.chatgpt + q.citations.perplexity + q.citations.gemini + q.citations.claude > 0).length} hint={`of ${tracked}`} tone="ok" />
        </div>
      </section>

      <section>
        <SectionLabel>Tracked queries</SectionLabel>
        <div className="rounded-2xl border border-cream/10 bg-cream/[0.02] overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-[0.2em] text-cream/40 border-b border-cream/[0.06]">
                <th className="px-5 py-3 font-medium">Query</th>
                <th className="px-3 py-3 font-medium">Intent</th>
                <th className="px-3 py-3 font-medium text-right">ChatGPT</th>
                <th className="px-3 py-3 font-medium text-right">Perplexity</th>
                <th className="px-3 py-3 font-medium text-right">Gemini</th>
                <th className="px-3 py-3 font-medium text-right">Claude</th>
                <th className="px-5 py-3 font-medium text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {QUERIES.map((q) => {
                const total = q.citations.chatgpt + q.citations.perplexity + q.citations.gemini + q.citations.claude;
                return (
                  <tr key={q.id} className="border-b border-cream/[0.04] last:border-0 hover:bg-cream/[0.02] transition-colors">
                    <td className="px-5 py-3 text-cream/85">{q.query}</td>
                    <td className="px-3 py-3"><StatusPill tone="neutral">{q.intent}</StatusPill></td>
                    <td className="px-3 py-3 text-right tabular-nums text-cream/75">{q.citations.chatgpt}</td>
                    <td className="px-3 py-3 text-right tabular-nums text-cream/75">{q.citations.perplexity}</td>
                    <td className="px-3 py-3 text-right tabular-nums text-cream/75">{q.citations.gemini}</td>
                    <td className="px-3 py-3 text-right tabular-nums text-cream/75">{q.citations.claude}</td>
                    <td className="px-5 py-3 text-right tabular-nums text-cream font-medium">{total}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
